import {Container} from "./styled";
import {Header, Table} from "./lib";

interface ProductsProps {}

export const Products: React.FC<ProductsProps> = () => {
  return (
    <Container>
      <Header />
      <Table />
    </Container>
  );
};
